import React, { useContext, useState, useRef, useEffect } from 'react';
import finvu from '../../assets/finvu.png';
import finvuConsentRevoke from '../../assets/FinvuConsentRevoke.svg';
import personLogo from '../../assets/person.svg';
import useIsMobile from '../../hooks/useIsMobile';
import { UserContext } from '../../context/UserContext';
import { useHistory } from 'react-router-dom';
import AuthApis from '../../helper/api.service';
import { postMessage } from '../../utils/common.utils';
import { toast } from 'material-react-toastify';

const Header = ({ customDetails }) => {
    const isMobile = useIsMobile();
    const { userId, clearConsentCache } = useContext(UserContext);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const history = useHistory();
    const authApis = new AuthApis();

    // Add CSS animation styles
    const fadeInStyle = `
        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(-10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    `;

    // Close dropdown when clicking outside
    useEffect(() => {
        // Add animation styles to document head
        const styleElement = document.createElement('style');
        styleElement.textContent = fadeInStyle;
        document.head.appendChild(styleElement);

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.head.removeChild(styleElement);
        };
    }, []);

    const handleUserClick = () => {
        setShowDropdown(!showDropdown);
    };

    const handleLogout = () => {
        // Clear cache on logout
        clearConsentCache();
        
        authApis.logout(userId).then((res) => {
            postMessage('window', 'CLOSED');
            if (res?.status === 'SUCCESS') {
                toast.success('Logged out successfully');
                setTimeout(() => {
                    history.push('/');
                    window.location.reload();
                }, 1000);
            } else {
                toast.error(res?.message || 'Logout failed');
            }
        }).catch(() => {
            toast.error('Logout failed');
        });
        
        setShowDropdown(false);
    };

    return (
        <nav
            className="navbar fixed-top py-2"
            style={{ borderBottom: '1.5px solid #e0e0e0', backgroundColor: '#fff' }}
        >
            <div className="container" style={{ width: isMobile ? '100%' : '70%' }}>
                <div
                    className="d-flex align-items-center justify-content-between w-100"
                    style={{ flexWrap: 'wrap' }}
                >
                    <div className="navbar-brand d-flex align-items-center">
                        <img
                            src={finvuConsentRevoke}
                            className="finvu-logo"
                            height={isMobile ? '18px' : '25px'}
                            style={{ maxHeight: isMobile ? '18px' : '25px' }}
                        />
                    </div>
                    {userId && (
                        <div style={{ position: 'relative' }} ref={dropdownRef}>
                            <span
                                onClick={handleUserClick}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: isMobile ? '10px' : customDetails?.fontSize,
                                    fontWeight: 'bold',
                                    border: '1.5px solid #ccc',
                                    borderRadius: '20px',
                                    padding: isMobile ? '2px 8px 2px 6px' : '4px 14px 4px 10px',
                                    background: showDropdown ? '#f8f9fa' : '#fff',
                                    marginTop: isMobile ? '6px' : 0,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    borderColor: showDropdown ? customDetails?.primaryColor || '#007bff' : '#ccc',
                                }}
                            >
                                <img src={personLogo} alt="person" style={{ height: isMobile ? '16px' : '22px', marginRight: '6px' }} />
                                <span>{userId}</span>
                            </span>
                            
                            {showDropdown && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 'calc(100% + 4px)',
                                        right: 0,
                                        backgroundColor: '#ffffff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        boxShadow: '0 1px 6px rgba(0,0,0,0.12)',
                                        zIndex: 1000,
                                        minWidth: '80px'
                                    }}
                                >
                                    <div
                                        onClick={handleLogout}
                                        style={{
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            fontSize: '12px',
                                            color: '#666',
                                            fontWeight: '400',
                                            whiteSpace: 'nowrap',
                                            borderRadius: '6px',
                                            transition: 'all 0.15s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f8f9fa';
                                            e.target.style.color = '#333';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = '#666';
                                        }}
                                    >
                                        Logout
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Header;